// extracted by mini-css-extract-plugin
export default {"wrapper":"Problem_wrapper__IqnrX","icon":"Problem_icon__X6Mka","problem":"Problem_problem__zZZ4m","solution":"Problem_solution__Gi1xL"};